import * as React from 'react';
import Svg, { Path } from 'react-native-svg';

import { ds } from '@/components/lib/design.system';

const SvgComponent = props => (
    <Svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" {...props}>
        <Path
            d="M11.4907 20V18.4397C9.30258 18.2458 7.56687 16.9348 7.41914 14.8759L7.40991 14.7467H9.01637L9.03484 14.8575C9.21949 15.9192 9.9027 16.8148 11.4907 16.9902V12.5493L11.2783 12.4939C8.97944 11.94 7.74228 10.9152 7.74228 9.08713V9.0779C7.74228 7.10213 9.31182 5.76342 11.4907 5.5603V4H12.5986V5.55107C14.7221 5.74495 16.3193 7.10213 16.4486 9.04097L16.4578 9.17946H14.8513L14.8421 9.09636C14.7129 7.93306 13.845 7.16676 12.5986 7.00981V11.2475L12.8848 11.3122C15.2576 11.8846 16.5871 12.8632 16.5871 14.8113V14.8205C16.5871 17.0364 14.7683 18.2827 12.5986 18.4489V20H11.4907ZM9.34875 9.00404C9.34875 9.90883 9.91193 10.592 11.4907 10.9798V7.00981C10.0874 7.20369 9.34875 8.09925 9.34875 8.99481V9.00404ZM12.654 12.8263L12.5986 12.8171V17.0087C14.3159 16.8702 14.9806 15.9931 14.9806 14.9221V14.9129C14.9806 13.9065 14.4728 13.2695 12.654 12.8263Z"
            fill={ds.colorValue.icon.primary}
        />
    </Svg>
);
export default SvgComponent;
